import { GxIcon } from './icon.js'



export class GxIconMedal extends GxIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" 
  width="24" 
  height="24" viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
  <circle cx="12" cy="8" r="6"></circle>
</svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-medal")) {
  window.customElements.define("gx-icon-medal", GxIconMedal)
}
